module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_8017.35767c9f.png";